/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions, FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions';
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamToJSON(json) {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptions(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsSteamOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPlatformDataOptionsSteam.js.map